// Local translations
export const T = {
  en_GB: {
    products: "Products",
    productTypes: "Product Types",
    goalTypes: "Goal Types",
    wrapperTypes: "Wrapper Types",
    clientPreferences: "Client Preferences",
    platforms: "Platforms",
    mandates: "Mandates",
    sustainability: "Sustainability",
    documents: "Documents",
    assetClasses: "Asset Classes",
    correlations: "Correlations",
    portfolios: "Portfolios",
    dynamicPortfolios: "Dynamic Portfolios",
    costs: "Costs",
    settings: "Settings",
    tabWarning: "(warning)",
  },
  nb_NO: {
    products: "Produkter",
    productTypes: "Produkttyper",
    goalTypes: "Måltyper",
    wrapperTypes: "Innpakningstyper",
    clientPreferences: "Kundepreferanser",
    platforms: "Plattformer",
    mandates: "Mandater",
    sustainability: "Bærekraft",
    documents: "Dokumenter",
    assetClasses: "Aktivaklasser",
    correlations: "Korrelasjoner",
    portfolios: "Porteføljer",
    dynamicPortfolios: "Dynamiske porteføljer",
    costs: "Kostnader",
    settings: "Innstillinger",
    tabWarning: "(advarsel)",
  },
} as const;
